import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { AppSettingsService } from './appsettings.service';
import { RequestResult } from '../../model/RequestResult';
import * as _ from 'lodash';
@Injectable()
export class AuthService {
    private tokenKey = 'token';
    private rolesKey = 'roles';
    private groupsKey = 'groups';
    private userName = 'userName';
    private expires = 'expires';
    private haveToChangePassword = 'haveToChangePassword';
    private token: string;
    private roles: string[];
    private groups: string[];

    constructor(
        private http: Http,
        private settings: AppSettingsService
    ) { }

    login(userName: string, password: string): Promise<RequestResult> {
        return this.http.post(this.settings.getAppSetting('loginTokenUri'),
            'userName=' + userName +
            '&password=' + password +
            '&grant_type=password').toPromise()
            .then(response => {
                let result = new RequestResult();
                result.data = response.json();
                var exp = _.get(result.data, '.expires');

                localStorage.setItem(this.tokenKey, result.data.access_token);
                localStorage.setItem(this.rolesKey, result.data.roles);
                localStorage.setItem(this.groupsKey, result.data.groups);
                localStorage.setItem(this.userName, userName);
                localStorage.setItem(this.expires, exp.toString());
                localStorage.setItem(this.haveToChangePassword, result.data.haveToChangePassword);

                return result;
            })
            .catch(this.handleError);
    }

    logout() {
        this.groups = null;
        this.roles = null;
        this.token = null;
        localStorage.removeItem(this.tokenKey);
        localStorage.removeItem(this.rolesKey);
        localStorage.removeItem(this.groupsKey);
        localStorage.removeItem(this.userName);
        localStorage.removeItem(this.expires);
        localStorage.removeItem(this.haveToChangePassword);
    }

    isAuthenticated(): boolean {
        let token = localStorage.getItem(this.tokenKey);
        let expire = localStorage.getItem(this.expires);
        if (new Date(expire) < new Date()) {
            this.logout();
            return false;
        }
        return token != null;
    }

    getUserName(): string {
        return localStorage.getItem(this.userName);
    }

    getUserInfo(): Promise<RequestResult> {
        return this.authGet(this.settings.getAppSetting('loginTokenUri'));
    }

    post(url: string, body: any): Promise<RequestResult> {
        return this.http.post(url, body).toPromise()
            .then(response => {
                return response.json() as RequestResult;
            })
            .catch(this.handleError);
    }

    authPost(url: string, body: any): Promise<RequestResult> {
        let headers = this.initAuthHeaders();
        return this.http.post(url, body, { headers: headers }).toPromise()
            .then(response => {
                return response.json() as RequestResult;
            })
            .catch(this.handleError);
    }

    authDelete(url: string): Promise<RequestResult> {
        let headers = this.initAuthHeaders();
        return this.http.delete(url, { headers: headers }).toPromise()
            .then(response => {
                return response.json() as RequestResult;
            })
            .catch(this.handleError);
    }

    authPut(url: string, body: any): Promise<RequestResult> {
        let headers = this.initAuthHeaders();
        return this.http.put(url, body, { headers: headers }).toPromise()
            .then(response => {
                return response.json() as RequestResult;
            })
            .catch(this.handleError);
    }


    authGet(url: any): Promise<RequestResult> {
        let headers = this.initAuthHeaders();
        return this.http.get(url, { headers: headers }).toPromise()
            .then(response => {
                return response.json() as RequestResult;
            })
            .catch(this.handleError);
    }
    authPostWithoutParam(url: string, params: any): Promise<RequestResult> {
        let headers = this.initAuthHeaders();
        console.log(headers);
        return this.http.post(url, params, { headers: headers }).toPromise()
            .then(response => {
                return response.json() as RequestResult;
            })
            .catch(this.handleError);
    }

    authGetWithParam(url: any, params: any): Promise<RequestResult> {
        let headers = this.initAuthHeaders();
        return this.http.get(url, { headers: headers, search: params }).toPromise()
            .then(response => {
                return response.json() as RequestResult;
            })
            .catch(this.handleError);
    }

    hasRole(role: string): boolean {
        return this.hasRoles([role]);
    }

    hasRoles(roles: string[]): boolean {
        roles = roles || [];

        let _res = true;
        let userRoles = this.getLocalRoles();
        for (let i = 0, len = roles.length; i < len; i++) {
            let _userHasRole = false;
            for (let q = 0, len = userRoles.length; q < len; q++) {
                if (roles[i] == userRoles[q]) {
                    _userHasRole = true;
                    break;
                }
            }

            if (_res && !_userHasRole) {
                _res = false;
                break;
            }
        }

        return _res;
    }

    hasAnyRoles(roles: string[]): boolean {
        roles = roles || [];
        let userRoles = this.getLocalRoles();
        for (let i = 0, len = roles.length; i < len; i++) {
            for (let q = 0, len = userRoles.length; q < len; q++) {
                if (roles[i] == userRoles[q]) {
                    return true;
                }
            }
        }

        return false;
    }

    userHaveToChangePassword(): boolean {
        let change = localStorage.getItem(this.haveToChangePassword);
        if (change != null) {
            return change.toLowerCase() === 'true';
        }

        return false;
    }

    refreshUserRights() {
        let url = this.settings.getAppSetting('apiUri') + 'user/current';
        let result = this.authGet(url);
        result.then((userInfo) => {
            userInfo.data = JSON.parse(<string>userInfo.data);
            localStorage.setItem(this.rolesKey, userInfo.data['roles']);
            localStorage.setItem(this.groupsKey, userInfo.data['groups']);

            delete this.roles;
            delete this.groups;
        });
    }

    private getLocalToken(): string {
        if (this.token == null) {
            this.token = localStorage.getItem(this.tokenKey);
        }
        return this.token;
    }

    private getLocalRoles(): string[] {
        if (this.roles == null) {
            this.roles = JSON.parse(localStorage.getItem(this.rolesKey));
        }
        return this.roles;
    }

    private getLocalGroups(): string[] {
        if (this.groups == null) {
            this.groups = JSON.parse(localStorage.getItem(this.groupsKey));
        }
        return this.groups;
    }

    private initAuthHeaders(): Headers {
        let token = this.getLocalToken();
        if (token == null) {
            throw 'No token';
        }

        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + token);

        return headers;
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/shared/services/authentication.service.ts